import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { BaseForm, BaseInput, BaseSelect, CELL_PHONE_MASK, CPF_MASK } from "react-epharma-components";
import { ICrudFormProps } from "@interfaces/crudForm";
import { USER_GENDER_OPTIONS } from "@enums/UserGenderEnum";
import { USER_STATUS_OPTIONS } from "@enums/UserStatusEnum";

const CrudForm: React.FC<ICrudFormProps> = (props) => {
  const cpf = React.createRef<BaseInput>();
  const name = React.createRef<BaseInput>();
  const lastName = React.createRef<BaseInput>();
  const email = React.createRef<BaseInput>();
  const mobilePhoneNumber = React.createRef<BaseInput>();
  const birthDate = React.createRef<BaseInput>();
  const gender = React.createRef<BaseSelect>();
  const status = React.createRef<BaseSelect>();
  const justification = React.createRef<BaseInput>();
  const _this = React.createRef<BaseForm>();

  const inputRefs = [cpf, name, lastName, email, mobilePhoneNumber, status, birthDate, gender, justification];


  useEffect(() => {
    if (props.data && props?.data[0]?.birthDate && !!birthDate.current) {
      birthDate.current.setValue(props.data[0].birthDate.split("T")[0]);
    }
  }, [props.data]);

  return (
    <BaseForm refs={inputRefs} ref={_this} {...props}>
      <Row>
        <Col xs="3" sm="3" md="3" lg="3" xl="3">
          <BaseInput label="CPF" name="cpf" id="cpf" mask={CPF_MASK} ref={cpf} disabled />
        </Col>
      </Row>
      <Row>
        <Col xs="6" sm="6" md="6" lg="6" xl="6">
          <BaseInput label="Nome" name="name" id="name" ref={name} required />
        </Col>
        <Col xs="6" sm="6" md="6" lg="6" xl="6">
          <BaseInput label="Sobrenome" name="lastName" id="lastName" ref={lastName} required />
        </Col>
      </Row>
      <Row>
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseInput label="E-mail" name="email" id="email" ref={email} required />
        </Col>
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseInput label="Telefone" name="mobilePhoneNumber" id="mobilePhoneNumber" mask={CELL_PHONE_MASK} ref={mobilePhoneNumber} required />
        </Col>
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseInput label="Data de nascimento" name="birthDate" id="birthDate" type="date" ref={birthDate} required />
        </Col>
      </Row>
      <Row>
        <Col xs="3" sm="3" md="3" lg="3" xl="3">
          <BaseSelect label="Gênero" name="gender" id="gender" ref={gender} options={USER_GENDER_OPTIONS} />
        </Col>
        <Col xs="3" sm="3" md="3" lg="3" xl="3">
          <BaseSelect label="Status" name="status" id="status" ref={status} options={USER_STATUS_OPTIONS} />
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="12" md="12" lg="12" xl="12">
          <BaseInput label="Justificativa da alteração" name="justification" id="justification" ref={justification} maxLength={150} required as="textarea" type="string" />
        </Col>
      </Row>
    </BaseForm>
  );
};

export default CrudForm;
